import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = {
  createControl: {method: 'POST', url: 'teacher{/id}/questionnaire'},
  getResponses: {method: 'GET', url: 'questionnaires{/id}/items'},
  getRecommendations: {method: 'GET', url: 'questionnaires{/id}/recommendations/items'},
  getRecommended: {method: 'GET', url: 'questionnaires{/id}/recommendations'},
  getComments: {method: 'GET', url: 'questionnaires{/id}/comments'},
  getPreviousRecommended: {method: 'GET', url: 'questionnaires{/id}/previousrecommendations'},
  putResponse: {method: 'PUT', url: 'questionnaires{/questionnaireId}/items{/itemId}'},
  createControlOfExisting: {method: 'POST', url: 'questionnaires/{id}/control'},
  saveRecommendations: {method: 'PUT', url: 'questionnaires/{id}/recommendations'},
  saveComments: {method: 'PUT', url: 'questionnaires/{id}/comments'},
  saveDescription: {method: 'PUT', url: 'questionnaires/{id}/description'},
  saveFirstTimeModel: {method: 'PUT', url: 'questionnaires/{id}/model'},
  finish: {method: 'PUT', url: 'questionnaires/{id}/finish'},
  undo: {method: 'DELETE', url: 'questionnaires{/questionnaireId}/items{/itemId}'},
  getFinished: {method: 'GET', url: 'questionnaires/finished'},
  getUnfinished: {method: 'GET', url: 'questionnaires/unfinished'},
  getErasableItems: {method: 'GET', url: 'questionnaires/{id}/erasable'},
  deleteItem: {method: 'POST', url: 'questionnaires/{questionnaireId}/items/{itemId}/erase'},
  keepItem: {method: 'POST', url: 'questionnaires/{questionnaireId}/items/{itemId}/keep'}
}

export const QuestionnaireResource = () => {
  return Vue.resource('questionnaires{/id}', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/questionnaire.js